module.exports = __webpack_public_path__ + "static/media/boy-15.9a11480d.svg";